import { useEffect, useState } from 'react';
import DropDownArrow from '../../atoms/Icons/DropDownArrow';
import { IBreadcrumbs } from '../../molecules/Breadcrumbs';
import { Province } from '../../../interface';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from '../../../store';
import eventClickDetailBranchSales from '../../../helpers/emarsys/branch-sales/eventClickDetailBranchSales';
import { FEATURE } from '../../../constants/emarsys/branch-sales';

interface Props {
  title?: string;
  description?: string;
  breadcrumbItems?: IBreadcrumbs[];
  feature?: string;
  branchProvince?: Province;
  city?: string;
  cityCode?: string;
  sectionName?: string;
  buttonName?: string;
  pageName?: string;
  pageTitle?: string;
}

const BranchInfoSection = ({
  title = '',
  description = '',
  feature = '',
  breadcrumbItems = [],
  branchProvince,
  city = '',
  cityCode = '',
  pageName = '',
  pageTitle = '',
  sectionName = '',
  buttonName = '',
}: Props) => {
  const dispatch = useDispatch();
  const { userData } = useSelector((state: IRootState) => state.auth) || {
    userData: null,
  };
  const [showMore, setShowMore] = useState(true);
  const [showAllContent, setShowAllContent] = useState(true);

  const formattedDescription = description.replace(/\n/g, '<br />');
  const [content, setContent] = useState(formattedDescription);

  const eventClickEmarsys = () => {
    const basePayload = {
      dispatch,
      customerNo: userData?.customerNo,
      breadcrumbItems,
      pageName,
      pageTitle,
      sectionName,
      buttonName,
    };

    if (feature === FEATURE.SALES_LISTING_PAGE) {
      eventClickDetailBranchSales({
        ...basePayload,
        newParams: {
          menu_cat_lvl2: breadcrumbItems?.[2]?.name?.toUpperCase() ?? '',
          menu_cat_lvl3: breadcrumbItems?.[3]?.name?.toUpperCase() ?? '',
          menu_cat_lvl4: breadcrumbItems?.[4]?.name?.toUpperCase() ?? '',
        },
      });
    } else if (feature === FEATURE.BRANCH_LISTING_PAGE) {
      eventClickDetailBranchSales({
        ...basePayload,
        newParams: {
          province: branchProvince?.name ?? '',
          province_code: branchProvince?.isocode ?? '',
          city: city,
          city_code: cityCode,
          ...(breadcrumbItems?.[2]?.name
            ? {
                menu_cat_lvl2: breadcrumbItems?.[2]?.name?.toUpperCase(),
              }
            : {}),
        },
      });
    }
  };

  const toggleShowMore = () => {
    if (!showMore) {
      eventClickEmarsys();
    }
    setShowMore(!showMore);
    setShowAllContent(!showAllContent);
  };

  const isLongContent = formattedDescription.length > 320;

  useEffect(() => {
    setShowMore(false);
  }, []);

  useEffect(() => {
    const currentContent =
      isLongContent && !showMore ? formattedDescription.slice(0, 320) : formattedDescription;
    setContent(currentContent);
  }, [showMore]);

  return (
    <div className="lg:px-0 container" data-testid="information-section">
      <h2 className="text-base font-bold text-reliableBlack uppercase mb-[10px] lg:text-2xl lg:mb-5">
        {title}
      </h2>
      <div
        className={`branch-info prose max-sm:prose-li:text-sm content-description text-xs lg:text-base ${
          isLongContent && !showMore ? 'max-h-[96px]' : 'max-h-full'
        } overflow-hidden`}
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      />
      {isLongContent && (
        <label
          htmlFor="post-1"
          className="read-more-trigger text-sm font-semibold text-hyperLink uppercase lg:text-base mt-5 flex gap-3 items-center cursor-pointer"
        >
          <input
            type="checkbox"
            id="post-1"
            className="read-more-state hidden"
            checked={showMore}
            onChange={toggleShowMore}
          />
          <span>{showMore ? 'LIHAT LEBIH SEDIKIT' : 'LIHAT SELENGKAPNYA'}</span>
          <span className={`${showMore && 'rotate-180'}`}>
            <DropDownArrow size={11} fill="#036EBC" />
          </span>
        </label>
      )}
    </div>
  );
};

export default BranchInfoSection;
